import { Zap } from "lucide-react";

/** Pill, H2 and intro in the same shape as the home page sections. */
export function TradeSectionHeading({
  badge,
  title,
  intro,
  underline = false,
}: {
  badge: string;
  title: string;
  intro?: string;
  underline?: boolean;
}) {
  return (
    <div className="mb-10 space-y-4 text-center sm:mb-14">
      <div className="inline-flex items-center gap-2 rounded-full bg-primary/10 px-4 py-2 text-sm font-medium text-primary">
        <Zap className="h-4 w-4" aria-hidden />
        {badge}
      </div>
      <h2 className="text-3xl font-bold leading-tight text-foreground sm:text-4xl lg:text-5xl">
        {title}
      </h2>
      {intro ? (
        <p className="mx-auto max-w-3xl text-lg leading-relaxed text-muted-foreground sm:text-xl">
          {intro}
        </p>
      ) : null}
      {underline ? (
        <div className="flex justify-center pt-2" aria-hidden>
          <div className="h-1 w-20 rounded-full bg-gradient-to-r from-destructive via-muted to-success" />
        </div>
      ) : null}
    </div>
  );
}
